import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

import { AccordionItem } from 'modules/common';

function Accordion({
  options,
  className,
  accordionItemProps,
  isOpenCondition,
  withBorder,
  withOnOpenCloseOthers,
  isAccordionItemHidden,
  onOpenCloseOthersExcept,
  withLastBorder,
}) {
  const [form, setForm] = React.useState(options);

  const handleOnClick = (index) => {
    setForm((prevState) =>
      prevState?.map((item, key) => {
        if (key === index) {
          return {
            ...item,
            isOpen: !item?.isOpen,
          };
        }

        if (withOnOpenCloseOthers && !onOpenCloseOthersExcept(item)) {
          return {
            ...item,
            isOpen: false,
          };
        }

        return item;
      })
    );
  };

  const dispatchIsOpen = (row, index) => {
    if (typeof isOpenCondition === 'function') {
      return isOpenCondition(row, index);
    }

    return row?.isOpen || false;
  };

  React.useEffect(() => {
    setForm(
      options?.map((item, key) => ({ ...item, isOpen: form?.[key]?.isOpen }))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  return (
    <div
      className={cn('divide-y', className, {
        'border-t border-b border-default': withBorder,
        '!border-b-0': !withLastBorder,
      })}
    >
      {form?.map((item, key) => {
        if (
          isAccordionItemHidden &&
          typeof isAccordionItemHidden === 'function' &&
          isAccordionItemHidden(item)
        ) {
          return null;
        }

        return (
          <AccordionItem
            // eslint-disable-next-line react/no-array-index-key
            key={key}
            {...(typeof accordionItemProps === 'function'
              ? accordionItemProps(item, key)
              : accordionItemProps)}
            {...item}
            isOpen={item?.isOpen ?? dispatchIsOpen(item, key)}
            onClick={() => handleOnClick(key)}
          />
        );
      })}
    </div>
  );
}

Accordion.defaultProps = {
  options: [],
  className: '',
  accordionItemProps: {},
  isOpenCondition: false,
  withBorder: false,
  withLastBorder: false,
  withOnOpenCloseOthers: false,
  isAccordionItemHidden: false,
  onOpenCloseOthersExcept: () => {},
};

Accordion.propTypes = {
  isOpenCondition: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.instanceOf(Function),
  ]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      isOpen: PropTypes.bool,
      children: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.element,
        PropTypes.string,
        PropTypes.instanceOf(Object),
        PropTypes.instanceOf(Function),
      ]),
    })
  ),
  className: PropTypes.string,
  withBorder: PropTypes.bool,
  withLastBorder: PropTypes.bool,
  withOnOpenCloseOthers: PropTypes.bool,
  accordionItemProps: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.instanceOf(Function),
  ]),
  isAccordionItemHidden: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.instanceOf(Function),
  ]),
  onOpenCloseOthersExcept: PropTypes.instanceOf(Function),
};

export default Accordion;
